import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '@core/services/storages.service';
import { UserInfoIA } from '@modules/configuration-ia/interfaces/token/token.interface';
import { formatTimezone } from '@shared/helpers/functions/timezone-format.helper';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private url = 'https://qa.sicopweb.com/auth/10.0.0';
  public urlToken: string = '';

  constructor(
    private http: HttpClient,
    private activetedRoute: ActivatedRoute,
    private router: Router,
    private storageService: StorageService
  ) { }

  public getTokenConfigIa(){
    let body = new HttpParams();

    body = body.set('Token', this.getUrlToken());

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<UserInfoIA>(`${this.url}/login`, body,{ headers }).pipe(take(1));
  }

  private getUrlToken(): string {
    const routeToken = this.activetedRoute.snapshot.queryParamMap.get('token');
    const urlToken = this.router.parseUrl(this.router.url).queryParams['token'];
    const token = routeToken ?? urlToken ?? '';
    const normalizedToken = this.removeSpace(token);
    this.urlToken = normalizedToken;
    return normalizedToken;
  }

  public setUserIALocalStorage(values: any){
    this.storageService.setLocalStorage('userInfo', values);
  }

  public deleteUserAILocalStorage(){
    this.storageService.removeLocalStorage('userInfo');
  }

  public removeSpace(value: string | null | undefined): string{
    return (value ?? '').replaceAll(' ', '+');
  }

  public setUserIASessionStorage(values: any){
    const dbEmpresa =
      values?.config?.basesDeDatos?.dbEmpresa ??
      values?.IdGrupoCorporativo ??
      values?.Database ??
      '';
    const idIdioma =
      values?.config?.idioma?.idIdioma ??
      values?.response?.configuracion?.idioma?.idIdioma ??
      'ES';
    const idPais =
      values?.config?.idioma?.idPais ??
      values?.response?.configuracion?.idioma?.idPais ??
      'MX';
    const timezoneNameRaw =
      values?.config?.husoHorario?.nombre ??
      values?.response?.configuracion?.husoHorario?.nombre ??
      values?.ZonaHoraria ??
      '';
    const timezoneName = formatTimezone(timezoneNameRaw);
    const timezoneId =
      values?.config?.husoHorario?.idHuso ??
      values?.response?.configuracion?.husoHorario?.idHuso ??
      timezoneName;

    const normalizedValues = {
      ...values,
      isIAUserInfo: true,
      config: {
        ...(values?.config ?? {}),
        basesDeDatos: {
          ...(values?.config?.basesDeDatos ?? {}),
          dbEmpresa,
        },
        idioma: {
          ...(values?.config?.idioma ?? {}),
          idIdioma,
          idPais,
        },
        husoHorario: {
          ...(values?.config?.husoHorario ?? {}),
          idHuso: timezoneId,
          nombre: timezoneName,
        },
      },
    };

    this.storageService.setSessionStorage('userInfo', normalizedValues);
  }

  public deleteUserAISessionStorage(){
    this.storageService.removeSessionStorage('userInfo');
  }

}
